import { Card, CardBody, Flex, Tag, TagGroup, Text } from '@backstage/ui';

import type { Selection } from 'react-aria-components';
import { severityDisplay } from '../../severity';
import styles from './EntityScorecardsTab.module.css';
import { useScorecardsFilter } from './ScorecardsFilterContext';
import { useSeverities } from '../../hooks/useSeverities';

const toStringSet = (sel: Selection): Set<string> => {
  if (sel === 'all') return new Set<string>();
  return new Set([...sel].map(String));
};

interface FailingChecksProps {
  failing: number;
  severityCounts: Map<string, number>;
}

export const FailingChecks = ({
  failing,
  severityCounts,
}: FailingChecksProps) => {
  const { activeSeverities, setActiveSeverities } = useScorecardsFilter();
  const { severities } = useSeverities();
  const visibleSeverities = severities.filter(
    sv => (severityCounts.get(sv.id) ?? 0) > 0,
  );
  return (
    <Card style={{ flex: 1 }}>
      <CardBody>
        <Text
          as="p"
          variant="body-small"
          color="secondary"
          weight="bold"
          className={styles.sectionLabel}
        >
          Failing Checks
        </Text>
        <Flex align="center" gap="2" className={styles.overallStats}>
          <Text
            as="span"
            variant="title-medium"
            style={{ color: 'var(--zf-sc-fail)' }}
          >
            {failing}
          </Text>
          <Text as="span" variant="body-small" color="secondary">
            Failing
          </Text>
        </Flex>
        <TagGroup
          selectionMode="multiple"
          selectionBehavior="toggle"
          selectedKeys={activeSeverities}
          onSelectionChange={keys => setActiveSeverities(toStringSet(keys))}
          aria-label="Filter by severity"
        >
          {visibleSeverities.map(sv => {
            const { label, colorVar, bgVar, fgVar } = severityDisplay(sv);
            return (
              <Tag
                key={sv.id}
                id={sv.id}
                size="medium"
                textValue={`${severityCounts.get(sv.id)!} ${label}`}
                className={styles.chip}
                style={{
                  background: bgVar,
                  border: `1px solid ${colorVar}`,
                  color: fgVar,
                }}
              >
                {severityCounts.get(sv.id)!} {label}
              </Tag>
            );
          })}
        </TagGroup>
      </CardBody>
    </Card>
  );
};
